import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

function Pastor() {
    const [pastorData, setPastorData] = useState(null);
    const [noPastorData, setNoPastorData] = useState(null);
    const { name } = useParams();

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getPastor/${name}`)
        .then((response) => {
            setPastorData(response.data);
        })
        .catch((error) => {
            console.error("There was an error fetching the data!", error);
        });
    }, []);

    if (!pastorData) {
        if (!noPastorData) {
            return (
                <div className="page-content">
                    <h2>牧者介紹</h2>
                    <p className='error'>
                        抱歉，牧者：&ldquo;{name}&rdquo;並不存在。
                    </p>
                    <Link to="/about">
                        <button className='button button-m'>
                            返回【教會簡介】
                        </button>
                    </Link>
                </div>
            );
        }
        return <div>加載中 Loading...</div>;
    }

    return (
        <div className="page-content">
        <h2>牧者介紹</h2>
        <h2>{pastorData.title}</h2>
        <div dangerouslySetInnerHTML={{ __html: pastorData.content }} />
        </div>
    );
}

export default Pastor;